export default [
  {
    label: 'bundles.instanceId',
    field: 'instanceId',
    filterable: true,
    sortable: true,
    type: 'number',
    placeholder: ' ',
    width: '100px',
  },
  {
    label: 'bundles.creationTime',
    field: 'instanceCreationDate',
    filterable: true,
    sortable: true,
    type: 'String',
    placeholder: ' ',
  },
  {
    label: 'bundles.templateId',
    field: 'templateId',
    filterable: true,
    sortable: true,
    placeholder: ' ',
    width: '250px',
  },
  {
    label: 'bundles.description',
    field: 'templateDescription',
    filterable: true,
    sortable: true,
    placeholder: ' ',
    width: '350px',
  },
  {
    label: 'bundles.state',
    field: 'instanceStateDescription',
    filterable: true,
    sortable: true,
    filterDropdown: true,
    filterOptions: [],
    placeholder: ' ',
  },
  {
    label: 'bundles.usableFrom',
    field: 'instanceUsableFrom',
    filterable: true,
    sortable: true,
    type: 'String',
    placeholder: ' ',
    width: '150px',
  },
  {
    label: 'bundles.usableTo',
    field: 'instanceUsableTo',
    filterable: true,
    sortable: true,
    type: 'String',
    placeholder: ' ',
    width: '150px',
  },
  {
    label: 'bundles.action',
    filterable: false,
    sortable: false,
    placeholder: ' ',
    ignoreOnHandleSearchFilter: true,
  },
];
